import { Input } from '../../../../components/Modules/Input'
import { useFeedbackWorkflow } from './FeedbackWorkflowContext'
import { LabelModule2 } from '../../../../components/Modules/LabelModule2'

const EmailInput = ({
    question, criteriaId, placeholder, required, answer, handleUpdate,
    feedbackType
}: {
    question: string,
    criteriaId: string,
    placeholder?: string,
    required?: boolean,
    answer: any,
    handleUpdate: Function,
    feedbackType: string
}) => {
    const { themeManager } = useFeedbackWorkflow();
    const labelStyles = themeManager?.getLabelStyles() 
    const inputStyles = themeManager?.getInputStyles()
    const emailText = themeManager?.getGeneralFeedbackEmailText?.(feedbackType);
    const emailErrorStyle = themeManager?.getGeneralFeedbackEmailErrorStyles?.(feedbackType);

    return (
        <>
            <div className="" key={criteriaId}>
                <LabelModule2
                    htmlFor={"normalInput"}
                    children={`${question}${required === true ? "*" : ""}`}
                    style={
                        // {
                        // ...themeManager?.getLabelStyles(),
                        // color:
                        //     themeManager?.getLabelStyles().color,
                    // }
                    labelStyles
                }
                />
                <Input
                    type="email"
                    style={
                        // {
                        // ...themeManager.getInputStyles(),
                        // color:
                        //     themeManager.getInputStyles().color,
                    // }
                    inputStyles
                }
                    placeholder={placeholder || question}
                    value={answer[criteriaId]}
                    onChange={(e) => handleUpdate(e, criteriaId, "")}
                    // emailtext={
                    //     styleConfigApi?.EmailError?.text == undefined
                    //         ? "This is not a valid email"
                    //         : styleConfigApi?.EmailError?.text
                    // }
                    emailtext={
                        // themeManager.getGeneralFeedbackEmailText(feedbackType)
                        emailText
                    }
                    // emailErrorStyle={styleConfigApi?.EmailError?.errorStyle}
                    emailErrorStyle={
                        // themeManager?.getGeneralFeedbackEmailErrorStyles(feedbackType)
                        emailErrorStyle
                    }
                    required={required}
                />
            </div>
        </>
    )
}

export default EmailInput